import {
  LOGGED_IN_EMPLOYEE_LOCATION,
  isUsEmployeeLocation,
  useLoggedInEmployee,
} from "./use-logged-in-employee.ts";

export const US_EMPLOYEE_LOCATION = LOGGED_IN_EMPLOYEE_LOCATION.US;
export { isUsEmployeeLocation };

/** Identifies US-specific UI from the signed-in employee's location. */
export function useIsUsEmployee(): boolean {
  return useLoggedInEmployee().isUs;
}
